import React from 'react';
import Icon from '../openplay/OpenPlayIcon';

const MapStatusOverlay = ({ status, error }) => {
  if (status === 'ready') return null;

  if (status === 'missing_key') {
    return (
      <div className="absolute inset-0 flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-card rounded-xl border border-border shadow-elevation-2 p-6 text-center space-y-3">
          <div className="w-16 h-16 mx-auto rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="MapIcon" size={32} className="text-primary" />
          </div>
          <p className="text-base font-semibold text-foreground">네이버 지도 Client ID가 필요합니다</p>
          <p className="text-sm text-muted-foreground caption">
            <code className="px-1.5 py-0.5 rounded bg-muted text-foreground">.env</code>에
            <code className="px-1.5 py-0.5 rounded bg-muted text-foreground ml-2">VITE_NAVER_MAPS_CLIENT_ID</code>를 설정한 뒤
            dev server를 재시작하세요.
          </p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="absolute inset-0 flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-card rounded-xl border border-border shadow-elevation-2 p-6 text-center space-y-3">
          <p className="text-base font-semibold text-foreground">지도를 불러오지 못했습니다</p>
          <p className="text-sm text-muted-foreground caption">
            네이버 지도 Open API 인증이 실패하였습니다. 클라이언트 아이디와 웹 서비스 URL을 확인해 주세요.
          </p>
          {error?.message && (
            <div className="text-left text-xs text-muted-foreground caption bg-muted rounded-lg p-3 space-y-1">
              <div className="break-all">
                <span className="font-semibold text-foreground">error:</span> {error.message}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-muted-foreground caption">지도를 불러오는 중...</p>
      </div>
    </div>
  );
};

export default MapStatusOverlay;
